import { motion } from "framer-motion";
import { useRef, useState } from "react";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
import { toast } from "react-hot-toast";
import { Link } from "react-router-dom";

export default function Contact() {
  const formRef = useRef();

  const [input, setInput] = useState({
    fname: "",
    projectname: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setInput((prev) => ({ ...prev, [name]: value }));
  //   setError("");
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "mobile") {
      updatedValue = value.replace(/\D/g, "");
    }

    setInput((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };


  const validateForm = (data) => {
    const errors = {};

    if (!data.fname.trim()) {
      errors.fname = "Full name is required";
    } else if (data.fname.length < 3) {
      errors.fname = "Minimum 3 characters required";
    }

    if (!data.projectname.trim()) {
      errors.projectname = "Project name is required";
    }

    if (!data.email.trim()) {
      errors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.email)) {
        errors.email = "Enter valid email address";
      }
    }

    if (!data.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (!/^\d+$/.test(data.mobile)) {
      errors.mobile = "Only numbers allowed";
    }

    if (!data.message.trim()) {
      errors.message = "Message is required";
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(input);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // const { fname, projectname, email, mobile, message } = input;
    // if (!fname || !projectname || !email || !mobile || !message) {
    //   setError("Please fill all the fields.");
    //   return;
    // }

    // .sendForm(
    //   "service_y3ltmts",
    //   "template_09zrqv4",
    //   formRef.current,
    //   "qmFI8BJH6fiwNd58v"
    // )

    emailjs
      .sendForm(
        "service_plgalyd",
        "template_lhwp83h",
        formRef.current,
        "I4wSPgwmEEfH4RcaN"
      )
      .then(() => {
        toast.success("Message sent successfully!", {
          duration: 1000,
          style: {
            background: "#228B22",
            border: "1px solid #228B22",
            padding: "14px 18px",
            color: "white",
            fontWeight: "500",
            fontSize: "14px",
            borderRadius: "8px",
          },
        });

        setInput({
          fname: "",
          projectname: "",
          email: "",
          mobile: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        toast.error("Failed to send message. Please try again.", {
          duration: 1000,
          style: {
            background: "#c50202",
            border: "1px solid #c50202",
            padding: "14px 18px",
            color: "white",
            fontWeight: "500",
            fontSize: "14px",
            borderRadius: "8px",
          },
        });
      });
  };
  return (
    <>
      <Helmet>
        <title>Contact Blockcryp | Get in Touch with Our Team</title>
        <meta
          name="description"
          content="Have questions or need a custom blockchain or AI solution? Contact Blockcryp’s expert team today. We’re here to help you build future-ready technology."
        />
        <meta
          name="keywords"
          content=" contact Blockcryp, blockchain development contact, AI services inquiry, Web3 development company contact, get in touch with Blockcryp, request blockchain quote, hire blockchain developers, custom AI solution provider, blockchain support team, contact for Web3 services"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="hero space80 position-relative">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-12 order-2 order-lg-1 text-center">
              <motion.h3
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text-primary fw-bold"
              >
                Get in Touch,
              </motion.h3>
              <motion.h2
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h2 fw-bold text-light mb-4"
              >
                We are always ready to help you
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Have questions or need assistance? Our team is always ready to
                support you. Whether it's a quick{" "}
                <br className="d-none d-lg-block"></br> inquiry or a detailed
                discussion, we're just a message away.
              </motion.p>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- hreo section end ---------- */}

      {/* ------- conatact us start --------- */}
      <section className="conatct space80">
        <div className="container">
          <div className="conatact_form">
            <div className="row">
              <div className="col-lg-4">
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="contact_detail"
                >
                  <h3 className="text-capitalize fw-bold mb-3">
                    contact information
                  </h3>
                  <p className="mb-4 text_14">
                    We’re here to help! Reach out to us for any questions,
                    feedback, or support — our team is ready to assist you.
                  </p>
                  <div className="d-flex gap-3 mb-3">
                    <Link
                      to="tel:+971586683449"
                      className="d-flex gap-2 link_btn"
                      style={{ color: "inherit" }}
                    >
                      <div className="conatact_icon">
                        <i className="fa-solid fa-phone-volume"></i>
                      </div>
                      <div>
                        <p>+971 58 668 3449</p>
                        {/* <p>+971 52 936 6418</p> */}
                      </div>
                    </Link>
                  </div>
                  <div className="d-flex gap-3 mb-3">
                    <Link
                      to="mailto:blockcryp833@gmail.com"
                      className="d-flex gap-2 link_btn"
                      style={{ color: "inherit" }}
                    >
                      <div className="conatact_icon">
                        <i className="fa-solid fa-envelope"></i>
                      </div>
                      <div>
                        <p>blockcryp833@gmail.com</p>
                      </div>
                    </Link>
                  </div>
                  <div className="d-flex gap-3 mb-3">
                    <div className="conatact_icon">
                      <i className="fa-solid fa-location-dot"></i>
                    </div>
                    <div>
                      <p>
                        United Arab Emirates{" "}
                      </p>
                      {/* <p>
                        United Arab Emirates , Bayz Tower, Marasi Drive,
                        Business Bay, Dubai{" "}
                      </p> */}
                    </div>
                  </div>
                  {/* <div className="d-flex gap-3 mb-3">
                    <Link
                      to="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="d-flex gap-2 link_btn"
                      style={{ color: "inherit" }}
                    >
                      <div className="conatact_icon">
                        <i className="fa-brands fa-microsoft"></i>
                      </div>
                      <div>
                        <p>Sam John</p>
                      </div>
                    </Link>
                  </div> */}
                  {/* <div className="d-flex gap-3 mb-3">
                    <div className="conatact_icon">
                      <i class="fa-solid fa-location-pin-lock"></i>
                    </div>
                    <div>
                      <p>00000</p>
                    </div>
                  </div> */}
                </motion.div>
              </div>
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="col-lg-8"
              >
                <form
                  ref={formRef}
                  onSubmit={handleSubmit}
                  className="contact-form ajax-contact"
                >
                  <div className="row">
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-3">
                        <label>Full Name</label>
                        <span className="text-danger ms-1">*</span>
                        <input
                          type="text"
                          className="form-control style-border"
                          name="fname"
                          placeholder="Full Name*"
                          value={input.fname}
                          onChange={handleChange}
                          id="name"
                        />
                        {errors.fname && <p style={{ color: "red" }}>{errors.fname}</p>}
                        {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-3">
                        <label>Project Name</label>
                        <span className="text-danger ms-1">*</span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Project Name*"
                          name="projectname"
                          id="name"
                          required=""
                          value={input.projectname}
                          onChange={handleChange}
                        />
                        {errors.projectname && <p style={{ color: "red" }}>{errors.projectname}</p>}
                        {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-3">
                        <label>Email</label>
                        <span className="text-danger ms-1">*</span>
                        <input
                          type="email"
                          className="form-control style-border"
                          name="email"
                          id="email"
                          placeholder="Email address*"
                          value={input.email}
                          onChange={handleChange}
                        />
                        {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                        {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-6">
                      <div className="mb-3">
                        <label>Mobile Number</label>
                        <span className="text-danger ms-1">*</span>
                        <div className="input_group">
                          <input
                            type="text"
                            className="form-control style-border"
                            name="mobile"
                            id="mobile"
                            placeholder="Mobile Number*"
                            value={input.mobile}
                            onChange={handleChange}
                            maxLength={10}
                          />
                          {errors.mobile && <p style={{ color: "red" }}>{errors.mobile}</p>}
                          {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12 col-sm-12">
                      <div className="mb-3">
                        <label>How Can I Help You</label>
                        <span className="text-danger ms-1">*</span>
                        <div className="input_group">
                          <textarea
                            name="message"
                            className="form-control style-border"
                            placeholder="How Can I Help You*"
                            value={input.message}
                            onChange={handleChange}
                            rows="4"
                          />
                          {errors.message && <p style={{ color: "red" }}>{errors.message}</p>}
                          {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <button
                        className="button theme_btn mt-4 mt-lg-0"
                        type="submit"
                      >
                        Send Inquiry
                      </button>
                    </div>
                  </div>
                </form>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ------- conatact us end --------- */}

      {/* --------------- cta start  ------------- */}
      <section className="cta space80">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 ">
              <div className="text-center">
                <ScrollFloat
                  animationDuration={1}
                  ease="back.inOut(2)"
                  scrollStart="center bottom+=50%"
                  scrollEnd="bottom bottom-=40%"
                  stagger={0.09}
                  textClassName="text_70 mb-3 text-uppercase fw-semibold talk_heading text-primary"
                >
                  Tell Us Your New Ideas
                </ScrollFloat>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  a dynamic design excelling in transforming imaginative
                  concepts into vivid realities through{" "}
                  <br className="d-none d-lg-block"></br> innovative strategies
                  and compelling creative executions.
                </motion.p>

                <a
                  href="https://teams.live.com/l/invite/FEAgoDJPJi4z_OT7QI"
                  target="_blank"
                >
                  <motion.button
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    type="button"
                    className="button talk_btn theme_btn mt-3"
                  >
                    let's talk
                    <i className="fa-solid fa-circle-arrow-right ms-3"></i>
                  </motion.button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* --------------- cta end  ------------- */}
    </>
  );
}
